export default "__VITE_ASSET__ad1996f2__"